import { Request, Response, RequestConfig, Middleware } from "./common";
import { FetchMiddleware } from "./middlewares/fetch.middleware";

const UserAgent = "user-agent";
const ContentType = "content-type";
const ApplicationJson = "application/json";


export abstract class HTTPClient {
  constructor(protected baseUrl: string, protected name: string, protected readonly middlewares: Middleware[] = []) {
    middlewares.push(new FetchMiddleware());
  }

  protected async send<T>(config: RequestConfig): Promise<T> {
    if (this.middlewares.length === 0)
      throw new Error("No middleware were added");

    const request = this.buildRequestObject(config as Request);
    let index = 0;
    const runner = (): Promise<Response> => {
      return this.middlewares[index++].onRequest(request, runner);
    };
    const r = await runner();
    return r.body as T;
  }

  private buildRequestObject(request: Request): Request {
    let path = request.path;
    if (request.params) {
      for (const param in request.params) {
        path = path.replaceAll(`:${param}`, request.params[param]);
      }
    }

    request.url = new URL(path, this.baseUrl);
    if (request.query) {
      for (const name in request.query) {
        const value = request.query[name];
        if (value === undefined)
          continue;

        request.url.searchParams.set(name, Array.isArray(value) ? value.join(",") : value);
      }
    }

    if (request.body && !(request.body instanceof FormData))
      request.headers = { [UserAgent]: this.name, [ContentType]: ApplicationJson, ...request.headers };
    else
      request.headers = { [UserAgent]: this.name, ...request.headers };
    return request;
  }
}
